export const ErrorCode = {
  EXPIRED_ACCESS_TOKEN: 'not_authenticated',
};
